import type { ReactElement } from 'react';
import { Gauge } from 'lucide-react';
import FeatureNavLayout from '@/shared/surfaces/FeatureNavLayout';
import type { FeatureNavItem } from '@/shared/surfaces/FeatureNavTypes';
import { useSurface } from '@/shared/surfaces/useSurface';
import TopicNotFound from '@/shared/surfaces/TopicNotFound';
import { ADOPTION_CATALOG } from '@/features/behavior/BehaviorAdoptionCatalog';

function adoptionNavItems(basePath: string): FeatureNavItem[] {
    return [
        { path: basePath, label: 'Overview', icon: Gauge, matchPaths: [`${basePath}/drivers`] },
        ...ADOPTION_CATALOG.map((topic) => ({ path: `${basePath}/${topic.id}`, label: topic.navLabel ?? topic.title, icon: topic.icon })),
    ];
}

/**
 * The Adoption surface shell: a full-height interior sub-nav column (the
 * composite score Overview, then the heatmap and momentum drill-ins in catalog
 * order) beside its own scrollable content area. Drill-ins render inside the
 * outlet so the rail keeps the current view highlighted.
 */
export default function AdoptionLayout(): ReactElement {
    const surface = useSurface('adoption');
    if (surface === undefined) return <TopicNotFound />;

    return <FeatureNavLayout title="Adoption" ariaLabel="Adoption view" groups={[{ items: adoptionNavItems(surface.basePath), selectGroupLabel: 'Adoption' }]} />;
}
